import * as React from 'react';

import { CheckIcon } from 'lucide-react';

import { cn } from '../../../lib/stylingUtils';

interface StepProps {
  number: number;
  isCompleted: boolean;
  isCurrent: boolean;
  size?: 'small' | 'medium';
}

export const Step: React.FC<StepProps> = ({
  number,
  isCompleted,
  isCurrent,
  size = 'medium',
}) => (
  <div
    className={cn(
      '@Step',
      cn(
        'relative mr-2 flex size-6 items-center justify-center rounded bg-neutral/5 text-xs',
        isCompleted && 'bg-success text-white',
        isCurrent && 'border border-success bg-success/20 text-success',
        size === 'small' && 'size-5',
        size === 'medium' && 'size-6',
      ),
    )}
  >
    {isCompleted ? <CheckIcon className="size-4" /> : <span>{number}</span>}
  </div>
);
